import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Search, X, Link2 } from "lucide-react";

const TYPE_LABEL = { immobile: "Immobile", notizia: "Notizia", proprietario: "Venditore", acquirente: "Acquirente" };

export function EntitySearch({ kinds, value, onSelect, placeholder, testid }) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const timer = useRef();

  useEffect(() => {
    clearTimeout(timer.current);
    if (!q || q.trim().length < 2) { setResults([]); return; }
    timer.current = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/agenda/search", { params: { q, kinds: kinds.join(",") } });
        setResults(data); setOpen(true);
      } catch { setResults([]); } finally { setLoading(false); }
    }, 300);
    return () => clearTimeout(timer.current);
  }, [q]); // eslint-disable-line

  if (value) {
    return (
      <div data-testid={`${testid}-selected`} className="flex items-center gap-2 px-3 py-2.5 rounded-lg border border-[#FC82ED]/40 bg-[#FC82ED]/5 text-sm">
        <Link2 size={14} className="text-[#FC82ED] shrink-0" />
        <span className="flex-1 min-w-0 truncate"><b>{value.label}</b> <span className="text-[10px] uppercase text-[var(--muted)]">{TYPE_LABEL[value.type] || ""}</span></span>
        <button type="button" data-testid={`${testid}-clear`} onClick={() => { onSelect(null); setQ(""); }} className="p-1 rounded hover:bg-slate-100"><X size={14} /></button>
      </div>
    );
  }

  return (
    <div className="relative">
      <div className="flex items-center gap-2 px-3 py-2.5 rounded-lg bg-white border border-[var(--border)] focus-within:border-[#FC82ED] transition-colors">
        <Search size={14} className="text-[var(--muted)] shrink-0" />
        <input data-testid={testid} value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => results.length && setOpen(true)}
               placeholder={placeholder} className="flex-1 outline-none text-sm bg-transparent" />
      </div>
      {open && q.trim().length >= 2 && (
        <div className="absolute z-20 mt-1 w-full max-h-56 overflow-y-auto card-immo p-1 shadow-lg">
          {loading && <div className="px-3 py-2 text-xs text-[var(--muted)]">Ricerca…</div>}
          {!loading && results.length === 0 && <div className="px-3 py-2 text-xs text-[var(--muted)]">Nessun risultato. Puoi salvarlo come testo libero nel titolo.</div>}
          {results.map((r) => (
            <button type="button" key={`${r.type}-${r.id}`} data-testid={`${testid}-opt-${r.id}`} onClick={() => { onSelect(r); setOpen(false); }}
                    className="w-full text-left px-3 py-2 rounded-lg hover:bg-slate-50 flex items-center justify-between gap-2">
              <span className="min-w-0"><span className="text-sm font-medium block truncate">{r.label}</span>{r.sub && <span className="text-[11px] text-[var(--muted)] truncate block">{r.sub}</span>}</span>
              <span className="text-[9px] uppercase font-bold text-[#FC82ED] shrink-0">{TYPE_LABEL[r.type]}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
